import React from "react"
import { Table } from "sharedTypes"
import TagGuestList from "./TagGuestList"
import ChangeStatus from "./ChangeStatus"
import SendEmail from "./SendEmail/SendEmail"
import SendSmartReminder from "./SendSmartReminder"
import RemoveFromEvent from "./RemoveFromEvent"
import AssignSeat from "./AssignSeat"
import PrintBadge from "./PrintBadge/PrintBadge"

export type Actions = "tag-guest-list" | "change-status" | "send-email" | "send-smart-reminder" | "remove-from-event" | "assign-seat" | "print-badge"

type Props = {
  action: Actions | null
  onClose: () => void
  selectedCount: number
  tables: Table[]
}

const Action = ({
  action, onClose, selectedCount, tables,
}: Props) => {
  switch (action) {
    case "tag-guest-list":
      return <TagGuestList onClose={onClose} selectedCount={selectedCount} />
    case "change-status":
      return <ChangeStatus onClose={onClose} selectedCount={selectedCount} />
    case "send-email":
      return <SendEmail onClose={onClose} selectedCount={selectedCount} />
    case "send-smart-reminder":
      return <SendSmartReminder onClose={onClose} selectedCount={selectedCount} />
    case "remove-from-event":
      return <RemoveFromEvent onClose={onClose} />
    case "assign-seat":
      return <AssignSeat onClose={onClose} tables={tables} />
    case "print-badge":
      return <PrintBadge onClose={onClose} selectedCount={selectedCount} />
    default:
      return null
  }
}

export default Action
